import { YearModal } from './YearModal';
import { MonthModal } from './MonthModal';
import { DayModal } from './DayModal';
import { HourModal } from './HourModal';
import { MinuteModal } from './MinuteModal';
import { SecondModal } from './SecondModal';
import { RegionModal } from './RegionModal';
import { LatitudeModal } from './LatitudeModal';
import { LongitudeModal } from './LongitudeModal';
import { CommentDisclaimerModal } from './CommentDisclaimerModal';
import { EqLocNameModal } from './earthquake/EqLocNameModal';
import { EqTsunamiModal } from './earthquake/EqTsunamiModal';
import { EqVolcanoModal } from './earthquake/EqVolcanoModal';
import { EqMoreInfoModal } from './earthquake/EqMoreInfoModal';
import { EqIntensityModal } from './earthquake/EqIntensityModal';
import { EqMagnitudeModal } from './earthquake/EqMagnitudeModal';
import { EqLatitudeModal, EqLongitudeModal } from './earthquake/EqLatLongModals';
import { EqMbMagModal } from './earthquake/EqMbMagModal';
import { EqMfaMagModal } from './earthquake/EqMfaMagModal';
import { EqMlMagModal } from './earthquake/EqMlMagModal';
import { EqMsMagModal } from './earthquake/EqMsMagModal';
import { EqMwMagModal } from './earthquake/EqMwMagModal';
import { EqUnkMagModal } from './earthquake/EqUnkMagModal';
import { EqFocalDepthModal } from './earthquake/EqFocalDepthModal';
import { VolEventTsunamiModal } from './volcano/events/VolEventTsunamiModal';
import { VolEventEarthquakeModal } from './volcano/events/VolEventEarthquakeModal';
import { VolEventMoreInfoModal } from './volcano/events/VolEventMoreInfoModal';
import { VolLocNameModal } from './volcano/location/VolLocNameModal';
import { VolLocRegionsModal } from './volcano/location/VolLocRegionsModal';
import { VolLocRegionModal } from './volcano/location/VolLocRegionModal';
import { VolEventCountryModal } from './volcano/events/VolEventCountryModal';
import { VolLocElevationModal } from './volcano/location/VolLocElevationModal';
import { VolLocTypeModal } from './volcano/location/VolLocTypeModal';
import { VolEventVeiModal } from './volcano/events/VolEventVeiModal';
import { VolEventAgentModal } from './volcano/events/VolEventAgentModal';
import { VolEventDateModal } from './volcano/events/VolEventDateModal';
import { VolEventStartDateModal } from './volcano/events/VolEventStartDateModal';
import { VolEventEndDateModal } from './volcano/events/VolEventEndDateModal';
import { VolLocNumModal } from './volcano/location/VolLocNumModal';
import { VolLocNewNumModal } from './volcano/location/VolLocNewNumModal';
import { VolLocStatusModal } from './volcano/location/VolLocStatusModal';
import { VolTsunamiModal } from './volcano/events/VolTsunamiModal';
import { VolEarthquakeModal } from './volcano/events/VolEarthquakeModal';
import { VolLocTimeEruptModal } from './volcano/location/VolLocTimeEruptModal';
import { TsuValidityModal } from './tsunami/events/TsuValidityModal';
import { TsuCauseCodeModal } from './tsunami/events/TsuCauseCodeModal';
import { TsuAreaModal } from './tsunami/events/TsuAreaModal';
import { TsuRegionModal } from './tsunami/events/TsuRegionModal';
import { TsuVolcanoModal } from './tsunami/events/TsuVolcanoModal';
import { TsuMoreInfoModal } from './tsunami/events/TsuMoreInfoModal';
import { TsuDepositsModal } from './tsunami/events/TsuDepositsModal';
import { TsuCountryModal } from './tsunami/events/TsuCountryModal';
import { TsuLocationNameModal } from './tsunami/events/TsuLocationNameModal';
import { TsuLongitudeModal, TsuLatitudeModal } from './tsunami/events/TsuLatLongModals';
import { TsuMaxWaterHeightModal } from './tsunami/events/TsuMaxWaterHeightModal';
import { TsuRunupsModal } from './tsunami/events/TsuRunupsModal';
import { TsuMagAbeModal } from './tsunami/events/TsuMagAbeModal';
import { TsuMagIidaModal } from './tsunami/events/TsuMagIidaModal';
import { TsuIntensityModal } from './tsunami/events/TsuIntensityModal';
import { TsuWarnStatusModal } from './tsunami/events/TsuWarnStatusModal';
import { TsuCommentsModal } from './tsunami/events/TsuCommentsModal';
import { TsuOceanicModal } from './tsunami/events/TsuOceanicModal';
import { RuMoreInfoModal } from './tsunami/runups/RuMoreInfoModal';
import { RuDoubtfulModal } from './tsunami/runups/RuDoubtfulModal';
import { RuRegionModal } from './tsunami/runups/RuRegionModal';
import { RuCountryModal } from './tsunami/runups/RuCountryModal';
import { RuAreaModal } from './tsunami/runups/RuAreaModal';
import { RuLocationModal } from './tsunami/runups/RuLocationModal';
import { RuLatitudeModal, RuLongitudeModal } from './tsunami/runups/RuLatLongModals';
import { RuDistanceModal } from './tsunami/runups/RuDistanceModal';
import { RuArrDayModal, RuArrHourModal, RuArrMinuteModal } from './tsunami/runups/RuArrModals';
import { RuWaveTravelHourModal, RuWaveTravelMinuteModal } from './tsunami/runups/RuWaveTravelModals';
import { RuHeightModal } from './tsunami/runups/RuHeightModal';
import { RuInundationModal } from './tsunami/runups/RuInundationModal';
import { RuTroughModal } from './tsunami/runups/RuTroughModal';
import { RuMeasurementTypeModal } from './tsunami/runups/RuMeasurementTypeModal';
import { RuPeriodModal } from './tsunami/runups/RuPeriodModal';
import { RuFirstMotionModal } from './tsunami/runups/RuFirstMotionModal';
import { RuMaxArrDayModal, RuMaxArrHourModal, RuMaxArrMinuteModal } from './tsunami/runups/RuMaxArrModals';
import { MarLocNameModal } from './tsunami/marigrams/MarLocNameModal';
import { MarCountryModal } from './tsunami/marigrams/MarCountryModal';
import { MarStateModal } from './tsunami/marigrams/MarStateModal';
import { MarYearModal } from './tsunami/marigrams/MarYearModal';
import {
  EqDeathsModal,
  EqInjuriesModal,
  EqMissingModal,
  EqMissingDescriptionModal,
  EqDeathsDescriptionModal,
  EqInjuriesDescriptionModal,
  EqDamageModal,
  EqDamageDescriptionModal,
  EqHousesDestroyedModal,
  EqHousesDestroyedDescriptionModal,
  EqHousesDamagedModal,
  EqHousesDamagedDescriptionModal,
  EqTotalDeathsModal,
  EqTotalDeathsDescriptionModal,
  EqTotalMissingModal,
  EqTotalMissingDescriptionModal,
  EqTotalInjuriesModal,
  EqTotalInjuriesDescriptionModal,
  EqTotalDamageModal,
  EqTotalDamageDescriptionModal,
  EqTotalHousesDestroyedModal,
  EqTotalHousesDestroyedDescriptionModal,
  EqTotalHousesDamagedModal,
  EqTotalHousesDamagedDescriptionModal,
} from './earthquake/EqEffectsModals';
import {
  VolEventDeathsModal,
  VolEventDamageDescriptionModal,
  VolEventDamageModal,
  VolEventDeathsDescriptionModal,
  VolEventHousesDestroyedDescriptionModal,
  VolEventHousesDestroyedModal,
  VolEventInjuriesDescriptionModal,
  VolEventInjuriesModal,
  VolEventMissingDescriptionModal,
  VolEventMissingModal,
  VolEventTotalDamageDescriptionModal,
  VolEventTotalDamageModal,
  VolEventTotalDeathsDescriptionModal,
  VolEventTotalDeathsModal,
  VolEventTotalHousesDestroyedDescriptionModal,
  VolEventTotalHousesDestroyedModal,
  VolEventTotalInjuriesDescriptionModal,
  VolEventTotalInjuriesModal,
  VolEventTotalMissingDescriptionModal,
  VolEventTotalMissingModal,
} from './volcano/events/VolEventEffectsModals';
import {
  TsuDeathsModal,
  TsuDamageDescriptionModal,
  TsuDamageModal,
  TsuDeathsDescriptionModal,
  TsuHousesDamagedDescriptionModal,
  TsuHousesDamagedModal,
  TsuHousesDestroyedDescriptionModal,
  TsuHousesDestroyedModal,
  TsuInjuriesDescriptionModal,
  TsuInjuriesModal,
  TsuMissingDescriptionModal,
  TsuMissingModal,
  TsuTotalDamageDescriptionModal,
  TsuTotalDamageModal,
  TsuTotalDeathsDescriptionModal,
  TsuTotalDeathsModal,
  TsuTotalHousesDamagedDescriptionModal,
  TsuTotalHousesDamagedModal,
  TsuTotalHousesDestroyedDescriptionModal,
  TsuTotalHousesDestroyedModal,
  TsuTotalInjuriesDescriptionModal,
  TsuTotalInjuriesModal,
  TsuTotalMissingDescriptionModal,
  TsuTotalMissingModal,
} from './tsunami/events/TsuEffectsModals';
import {
  RuDeathsModal,
  RuDamageDescriptionModal,
  RuDamageModal,
  RuDeathsDescriptionModal,
  RuHousesDamagedDescriptionModal,
  RuHousesDamagedModal,
  RuHousesDestroyedDescriptionModal,
  RuHousesDestroyedModal,
  RuInjuriesDescriptionModal,
  RuInjuriesModal,
  RuMissingDescriptionModal,
  RuMissingModal,
} from './tsunami/runups/RuEffectsModals';
import { EqCountryModal } from './earthquake/EqCountryModal';
import { EqAreaModal } from './earthquake/EqAreaModal';
import { EqCommentsModal } from './earthquake/EqCommentsModal';
import { VolEventYearModal } from './volcano/events/VolEventYearModal';
import { VolEventCommentsModal } from './volcano/events/VolEventCommentsModal';
import { RuCommentsModal } from './tsunami/runups/RuCommentsModal';
import { MarLatitudeModal, MarLongitudeModal } from './tsunami/marigrams/MarLatLongModals';
import {
  RuMaxTroughDayModal,
  RuMaxTroughHourModal, RuMaxTroughMinuteModal,
} from './tsunami/runups/RuMaxTroughModals';
import { VolEventEruption } from './volcano/events/VolEventEruption';


export const helpModalIndex = {
  year: YearModal,
  month: MonthModal,
  day: DayModal,
  hour: HourModal,
  minute: MinuteModal,
  second: SecondModal,
  region: RegionModal,
  commentDisclaimer: CommentDisclaimerModal,
  eqLocName: EqLocNameModal,
  eqTsunami: EqTsunamiModal,
  eqVolcano: EqVolcanoModal,
  eqMoreInfo: EqMoreInfoModal,
  eqLatitude: EqLatitudeModal,
  eqLongitude: EqLongitudeModal,
  eqMbMag: EqMbMagModal,
  eqMfaMag: EqMfaMagModal,
  eqMlMag: EqMlMagModal,
  eqMsMag: EqMsMagModal,
  eqMwMag: EqMwMagModal,
  eqUnkMag: EqUnkMagModal,
  volEventTsunami: VolEventTsunamiModal,
  volEventEarthquake: VolEventEarthquakeModal,
  volEventMoreInfo: VolEventMoreInfoModal,
  volLocName: VolLocNameModal,
  volLocRegions: VolLocRegionsModal,
  volLocRegion: VolLocRegionModal,
  volEventCountry: VolEventCountryModal,
  latitude: LatitudeModal,
  longitude: LongitudeModal,
  volLocElevation: VolLocElevationModal,
  volLocType: VolLocTypeModal,
  volEventVei: VolEventVeiModal,
  volEventAgent: VolEventAgentModal,
  volEventDate: VolEventDateModal,
  volEventStartDate: VolEventStartDateModal,
  volEventEndDate: VolEventEndDateModal,
  volLocNum: VolLocNumModal,
  volLocNewNum: VolLocNewNumModal,
  volLocStatus: VolLocStatusModal,
  volLocTimeErupt: VolLocTimeEruptModal,
  volTsunami: VolTsunamiModal,
  volEarthquake: VolEarthquakeModal,
  eqMagnitude: EqMagnitudeModal,
  eqIntensity: EqIntensityModal,
  eqFocalDepth: EqFocalDepthModal,
  tsuValidity: TsuValidityModal,
  tsuCauseCode: TsuCauseCodeModal,
  tsuVolcano: TsuVolcanoModal,
  tsuMoreInfo: TsuMoreInfoModal,
  tsuDeposits: TsuDepositsModal,
  tsuCountry: TsuCountryModal,
  tsuArea: TsuAreaModal,
  tsuRegion: TsuRegionModal,
  tsuLocationName: TsuLocationNameModal,
  tsuLongitude: TsuLongitudeModal,
  tsuLatitude: TsuLatitudeModal,
  tsuMaxWaterHeight: TsuMaxWaterHeightModal,
  tsuRunups: TsuRunupsModal,
  tsuMagAbe: TsuMagAbeModal,
  tsuMagIida: TsuMagIidaModal,
  tsuIntensity: TsuIntensityModal,
  tsuWarnStatus: TsuWarnStatusModal,
  tsuComments: TsuCommentsModal,
  tsuOceanicTsunami: TsuOceanicModal,
  ruMoreInfo: RuMoreInfoModal,
  ruDoubtful: RuDoubtfulModal,
  ruRegion: RuRegionModal,
  ruCountry: RuCountryModal,
  ruArea: RuAreaModal,
  ruLocation: RuLocationModal,
  ruLatitude: RuLatitudeModal,
  ruLongitude: RuLongitudeModal,
  ruDistance: RuDistanceModal,
  ruArrDay: RuArrDayModal,
  ruArrHour: RuArrHourModal,
  ruArrMinute: RuArrMinuteModal,
  ruWaveTravelHour: RuWaveTravelHourModal,
  ruWaveTravelMinute: RuWaveTravelMinuteModal,
  ruHeight: RuHeightModal,
  ruInundation: RuInundationModal,
  ruMeasurementType: RuMeasurementTypeModal,
  ruPeriod: RuPeriodModal,
  ruFirstMotion: RuFirstMotionModal,
  ruMaxArrDay: RuMaxArrDayModal,
  ruMaxArrHour: RuMaxArrHourModal,
  ruMaxArrMinute: RuMaxArrMinuteModal,
  ruTroughHt: RuTroughModal,
  ruMaxTroughDay: RuMaxTroughDayModal,
  ruMaxTroughHour: RuMaxTroughHourModal,
  ruMaxTroughMinute: RuMaxTroughMinuteModal,

  eqDeaths: EqDeathsModal,
  eqDeathsDescription: EqDeathsDescriptionModal,
  eqMissing: EqMissingModal,
  eqMissingDescription: EqMissingDescriptionModal,
  eqInjuries: EqInjuriesModal,
  eqInjuriesDescription: EqInjuriesDescriptionModal,
  eqDamage: EqDamageModal,
  eqDamageDescription: EqDamageDescriptionModal,
  eqHousesDestroyed: EqHousesDestroyedModal,
  eqHousesDestroyedDescription: EqHousesDestroyedDescriptionModal,
  eqHousesDamaged: EqHousesDamagedModal,
  eqHousesDamagedDescription: EqHousesDamagedDescriptionModal,
  eqTotalDeaths: EqTotalDeathsModal,
  eqTotalDeathsDescription: EqTotalDeathsDescriptionModal,
  eqTotalMissing: EqTotalMissingModal,
  eqTotalMissingDescription: EqTotalMissingDescriptionModal,
  eqTotalInjuries: EqTotalInjuriesModal,
  eqTotalInjuriesDescription: EqTotalInjuriesDescriptionModal,
  eqTotalDamage: EqTotalDamageModal,
  eqTotalDamageDescription: EqTotalDamageDescriptionModal,
  eqTotalHousesDestroyed: EqTotalHousesDestroyedModal,
  eqTotalHousesDestroyedDescription: EqTotalHousesDestroyedDescriptionModal,
  eqTotalHousesDamaged: EqTotalHousesDamagedModal,
  eqTotalHousesDamagedDescription: EqTotalHousesDamagedDescriptionModal,

  volEventDeaths: VolEventDeathsModal,
  volEventDeathsDescription: VolEventDeathsDescriptionModal,
  volEventMissing: VolEventMissingModal,
  volEventMissingDescription: VolEventMissingDescriptionModal,
  volEventInjuries: VolEventInjuriesModal,
  volEventInjuriesDescription: VolEventInjuriesDescriptionModal,
  volEventDamage: VolEventDamageModal,
  volEventDamageDescription: VolEventDamageDescriptionModal,
  volEventHousesDestroyed: VolEventHousesDestroyedModal,
  volEventHousesDestroyedDescription: VolEventHousesDestroyedDescriptionModal,
  volEventTotalDeaths: VolEventTotalDeathsModal,
  volEventTotalDeathsDescription: VolEventTotalDeathsDescriptionModal,
  volEventTotalMissing: VolEventTotalMissingModal,
  volEventTotalMissingDescription: VolEventTotalMissingDescriptionModal,
  volEventTotalInjuries: VolEventTotalInjuriesModal,
  volEventTotalInjuriesDescription: VolEventTotalInjuriesDescriptionModal,
  volEventTotalDamage: VolEventTotalDamageModal,
  volEventTotalDamageDescription: VolEventTotalDamageDescriptionModal,
  volEventTotalHousesDestroyed: VolEventTotalHousesDestroyedModal,
  volEventTotalHousesDestroyedDescription: VolEventTotalHousesDestroyedDescriptionModal,
  volEventEruption: VolEventEruption,

  tsuDeaths: TsuDeathsModal,
  tsuDeathsDescription: TsuDeathsDescriptionModal,
  tsuMissing: TsuMissingModal,
  tsuMissingDescription: TsuMissingDescriptionModal,
  tsuInjuries: TsuInjuriesModal,
  tsuInjuriesDescription: TsuInjuriesDescriptionModal,
  tsuDamage: TsuDamageModal,
  tsuDamageDescription: TsuDamageDescriptionModal,
  tsuHousesDestroyed: TsuHousesDestroyedModal,
  tsuHousesDestroyedDescription: TsuHousesDestroyedDescriptionModal,
  tsuHousesDamaged: TsuHousesDamagedModal,
  tsuHousesDamagedDescription: TsuHousesDamagedDescriptionModal,
  tsuTotalDeaths: TsuTotalDeathsModal,
  tsuTotalDeathsDescription: TsuTotalDeathsDescriptionModal,
  tsuTotalMissing: TsuTotalMissingModal,
  tsuTotalMissingDescription: TsuTotalMissingDescriptionModal,
  tsuTotalInjuries: TsuTotalInjuriesModal,
  tsuTotalInjuriesDescription: TsuTotalInjuriesDescriptionModal,
  tsuTotalDamage: TsuTotalDamageModal,
  tsuTotalDamageDescription: TsuTotalDamageDescriptionModal,
  tsuTotalHousesDestroyed: TsuTotalHousesDestroyedModal,
  tsuTotalHousesDestroyedDescription: TsuTotalHousesDestroyedDescriptionModal,
  tsuTotalHousesDamaged: TsuTotalHousesDamagedModal,
  tsuTotalHousesDamagedDescription: TsuTotalHousesDamagedDescriptionModal,

  ruDeaths: RuDeathsModal,
  ruDeathsDescription: RuDeathsDescriptionModal,
  ruMissing: RuMissingModal,
  ruMissingDescription: RuMissingDescriptionModal,
  ruInjuries: RuInjuriesModal,
  ruInjuriesDescription: RuInjuriesDescriptionModal,
  ruDamage: RuDamageModal,
  ruDamageDescription: RuDamageDescriptionModal,
  ruHousesDestroyed: RuHousesDestroyedModal,
  ruHousesDestroyedDescription: RuHousesDestroyedDescriptionModal,
  ruHousesDamaged: RuHousesDamagedModal,
  ruHousesDamagedDescription: RuHousesDamagedDescriptionModal,

  marLocName: MarLocNameModal,
  marCountry: MarCountryModal,
  marState: MarStateModal,
  marYear: MarYearModal,
  marLongitude: MarLongitudeModal,
  marLatitude: MarLatitudeModal,

  eqCountry: EqCountryModal,
  eqArea: EqAreaModal,
  eqComments: EqCommentsModal,
  volEventYear: VolEventYearModal,
  volEventComments: VolEventCommentsModal,
  ruComments: RuCommentsModal,

};
